import React, { useState, createRef, useEffect, useRef } from 'react';
import styled from '../../../styled';
import { CascadeDropdownProvider, } from './useCascadeDropdownContext';
import { OptionsPanel, Trigger } from './components';
const Container = styled.div `
  position: relative;
`;
const CascadeDropdown = ({ children, options, defaultSelectedType = '', handleOptionChange, }) => {
    const [isDropdownOpen, setIsDropdownOpen] = useState(false);
    const [selectedType, setSelectedType] = useState(defaultSelectedType);
    const optionRef = createRef();
    const onClickTrigger = () => {
        setIsDropdownOpen(!isDropdownOpen);
    };
    const firstMounded = useRef(true);
    useEffect(() => {
        if (!firstMounded.current) {
            if (handleOptionChange)
                handleOptionChange(selectedType);
        }
        firstMounded.current = false;
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectedType]);
    useEffect(() => {
        setIsDropdownOpen(false);
    }, [selectedType]);
    return (React.createElement(CascadeDropdownProvider, { value: {
            options,
            isDropdownOpen,
            setIsDropdownOpen,
            selectedType,
            setSelectedType,
            optionRef,
        } },
        React.createElement(Container, { onClick: onClickTrigger }, children)));
};
CascadeDropdown.OptionsPanel = OptionsPanel;
CascadeDropdown.Trigger = Trigger;
export default CascadeDropdown;
//# sourceMappingURL=CascadeDropdown.js.map